<div class="step-container" [id]="ContainerId">

    <div *ngIf="VehicleInformation">
        <div class="step-title">
            <p>{{'EDIT_SERVICES.VEHICLE_ROUTE_STEP.0' | translate}}</p>
        </div>

        <div class="vehicle-card-container" *ngIf="VehicleInformation">
            <div class="vehicle-icon-container">
                <img [src]="ChassisType[VehicleInformation.ChassisType].icon" />
            </div>
            <div>
                <p class="vehicle-card-title">
                    {{VehicleInformation.Brand}} {{VehicleInformation.Model}}
                </p>
                <p class="vehicle-card-description">
                    {{VehicleInformation.LicensePlate}} ·
                    {{FuelType[VehicleInformation.FuelType]}} ·
                    {{ChassisType[VehicleInformation.ChassisType].description}}
                </p>
            </div>
        </div>
    </div>


    <div class="step-title" style="margin-top: 30px;">
        <div class="route-title-container">
            {{'EDIT_SERVICES.VEHICLE_ROUTE_STEP.1' | translate}}
            <div class="loading-routes" *ngIf="LoadingRoutes">
                <img src="../../../../../../../assets/gifs/loading-spinner.gif" alt="" />
                {{'EDIT_SERVICES.VEHICLE_ROUTE_STEP.5' | translate}}
            </div>
        </div>

        <div class="direction-container">
            <div>
                <img src="assets/icons/route-edit-service-icon.svg" alt="Arrow right icon" />
            </div>
            <div class="direcction-inputs-container">
                <div class="direction-label" [id]="OriginAddressId">
                    {{'EDIT_SERVICES.VEHICLE_ROUTE_STEP.2' | translate}}
                </div>
                <app-address-input (click)="scrollToChild(OriginAddressId)" [absoluteDropdown]="false"
                    [address]="AddressForm?.get('OriginAddress')?.get('Address')?.value"
                    (addressDataEmitter)="onOriginAddressDataEmitter($event)"></app-address-input>
                <div class="direction-label" style="margin-top: 15px;" [id]="DestinationAddressId">
                    {{'EDIT_SERVICES.VEHICLE_ROUTE_STEP.3' | translate}}
                </div>
                <app-address-input (click)="scrollToChild(DestinationAddressId)" [absoluteDropdown]="false"
                    [address]="AddressForm?.get('DestinationAddress')?.get('Address')?.value"
                    (addressDataEmitter)="onDestinationAddressDataEmitter($event)"></app-address-input>
            </div>
        </div>
    </div>
    <div *ngIf="ShowProductErrorMessage" [id]="ProducErrorId" class="error-container" style="margin-top: 30px;">
        <img src="../../../../../../../assets/icons/shield-exclamation-red.svg" alt="Error icon">
        <p class="error-text">{{'EDIT_SERVICES.VEHICLE_ROUTE_STEP.4' | translate}}</p>
    </div>
</div>